const selectEnabledCategories = state => {
	const all = state.brand.myNotificationsInboxAllCategoryEnabled;
	const promotions = state.brand.myNotificationsInboxPromotionsCategoryEnabled;
	const account = state.brand.myNotificationsInboxAccountCategoryEnabled;
	const sports = state.brand.myNotificationsInboxSportsCategoryEnabled;
	const casino = state.brand.myNotificationsInboxCasinoCategoryEnabled;
	const gameReleases = state.brand.myNotificationsInboxGameReleasesCategoryEnabled;
	return [all, promotions, account, sports, casino, gameReleases];
};

export default selectEnabledCategories;
